import services from './services';
import {
  cloneDeep,
  util,
  isCorrectVal,
  isDate,
  lg
} from "utils";
import {
  GetSendGoodsForBus,
  ERP_InvalidSendGoods,
  ERP_SendGoodsDel,
  GetOtherSendGoodsByPage
} from "@api/sendGoodsApi";
import NProgress from "nprogress";
import ViewPage from "./ViewPage/index.vue"

export default {
  mixins: [services],
  components: {
    ViewPage
  },
  data: function () {
    return {
      Session: util.getSessin(),
      queryType: this.$store.state.OutboundStatus,
      queryDelivery: [{
          TypeName: "-请选择-",
          TypeValue: "-1"
        },
        {
          TypeName: "未发货",
          TypeValue: "0"
        },
        {
          TypeName: "部分发货",
          TypeValue: "1"
        },
        {
          TypeName: "全部发货",
          TypeValue: "2"
        }
      ],
      loading2: false,
      lists: [{
        Id: "346567788"
      }],
      pageIndex: 1,
      pageSize: 10,
      totalSize: "",
      sels: [], //列表选中列
      SaleCheckView: false,
      pageSizes: [10, 20, 50],
      query: this.getQueryData()
    };
  },
  methods: {
    getQueryData() {
      return cloneDeep({
        OrderCode: "",
        SendCode: "",
        UserName: "",
        Status: "",
        DeliveryStatus: "",
      });
    },

    //通用输入参数
    getParams: function () {
      var para = {
        Sid: this.Session[0],
        Session: this.Session[1],
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        orderBy: this.orderBy
      };
      for (let item in this.query) {
        let value = this.query[item];
        if (value != "") {
          para[item] = value;
        }
      }
      return para;
    },

    selsChange: function (sels) {
      this.sels = sels;
    },
    //查询
    onQuerySubmit() {
      this.pageIndex = 1;
      this.getList()
      // this.pageIndex = 1;
      // this.lists = [];
      // this.loading2 = true; //拼命加载中显示
      // var para = this.getParams();
      // GetOtherSendGoodsByPage(para).then(res => {
      //   util.doResult(this, res, () => {});
      //   let {
      //     StateCode,
      //     StateMsg,
      //     Data,
      //     Cnt
      //   } = res.data;
      //   this.totalSize = Cnt;
      //   this.loading2 = false;
      //   this.lists = Data;
      //this.outTips(StateCode, StateMsg, Data, Cnt);
      // });
    }, //查询功能
    handleSizeChange: function (val) {
      this.pageSize = val;
      this.getList();
    },
    //查询单条
    handleView: function (index, row) {
      // 区分入口
      let path = this.$route.path
      let titleMsg = '出库单查看(海信)'
      if (path == '/Family/StockOutPackage') {
        // 资源包
        titleMsg = '出库单查看(资源包)'
      } else if (path == '/Family/StockOutHX') {
        // 海信
        titleMsg = '出库单查看(海信)'

      } else if (path == '/Family/StockOutStoreHouse') {
        // 仓库
        titleMsg = '出库单查看(仓库)'
      }
      this.$refs.refViewPage.show({
        StockOutId: row.StockOutId,
        title: titleMsg
      })

      // util.redirect(
      //   this,
      //   "/SendGoods/SendGoodsForHXView?Id=" + row.SendId,
      //   true
      // );
    },
    //修改生成出库单
    EditHandle: function (index, row) {

      let path = this.$route.path
      console.log(path)
      if (path == '/Family/StockOutPackage') {
        // 资源包
        util.redirect(this, "/Family/SendNoticePackage/CreatStockOutPage?StockOutId=" + row.StockOutId + "&update=true", false);
      } else if (path == '/Family/StockOutHX') {
        // 海信
        util.redirect(this, "/Family/SendNoticeHX/CreatStockOutPage?StockOutId=" + row.StockOutId + "&update=true", false);

      } else if (path == '/Family/StockOutStoreHouse') {
        // 仓库
        util.redirect(this, "/Family/SendNoticeStoreHouse/CreatStockOutPage?StockOutId=" + row.StockOutId + "&update=true", false);
      }

    },

    //删除
    // DelHandle: function (index, row) {
    //   this.$confirm("确认删除该发货通知单吗？", "提示", {
    //       type: "warning"
    //     })
    //     .then(() => {
    //       NProgress.start();
    //       let para = {
    //         Ids: row.SendId
    //       };
    //       ERP_SendGoodsDel(para).then(response => {
    //         NProgress.done();
    //         if (response.data.StateCode !== 0) {
    //           this.$notify({
    //             title: "错误",
    //             message: response.data.StateMsg,
    //             type: "error"
    //           });
    //         } else {
    //           this.$notify({
    //             title: "成功",
    //             message: "删除成功",
    //             type: "success"
    //           });
    //           this.getList();
    //         }
    //       });
    //     })
    //     .catch(() => {});
    // },
    //禁用
    // EnableHandle: function (index, row) {
    //   this.$confirm("确认作废该发货通知单吗？", "提示", {
    //       type: "warning"
    //     })
    //     .then(() => {
    //       NProgress.start();
    //       let para = {
    //         SendId: row.SendId,
    //         Sid: this.Session[0],
    //         Session: this.Session[1]
    //       };
    //       ERP_InvalidSendGoods(para).then(response => {
    //         NProgress.done();
    //         if (response.data.StateCode !== 0) {
    //           this.$notify({
    //             title: "错误",
    //             message: response.data.StateMsg,
    //             type: "error"
    //           });
    //         } else {
    //           this.$notify({
    //             title: "成功",
    //             message: "作废成功",
    //             type: "success"
    //           });
    //           this.getList();
    //         }
    //       });
    //     })
    //     .catch(() => {});
    // },
    handleCurrentChange: function (val) {
      this.pageIndex = val;
      this.getList();
    },
    //编辑功能
    onQueryClean: function () {
      this.query = this.getQueryData();
      this.getList();
    },
    created: function () {
      this.getList();
    }
  },
  watch: {
    $route(to, from) {
      this.getList();
      // if (this.$route.path == "/SendGoods/SendGoodsForHX") {
      //   this.getList();
      // }
    }
  },
  created() {
    this.getList();
  }
};


// WEBPACK FOOTER //
// ./src/pages/Family/StockOut/vm.js